import React from 'react';
import { cn } from '@hero/web-lib';

export interface StepProgressProps {
  /** Current step number (1-based). */
  current: number;
  /** Total number of steps. */
  total: number;
  className?: string;
}

/**
 * Two-segment (or N-segment) progress indicator for the signup wizard.
 * Mirrors the visual style on the previous register screen so the
 * cutover doesn't disrupt the user's mental model.
 */
export function StepProgress({ current, total, className }: StepProgressProps) {
  const segments = Array.from({ length: total }, (_, i) => i + 1);
  return (
    <div className={cn('flex w-full items-center gap-3', className)} aria-hidden>
      {segments.map(s => (
        <span
          key={s}
          className={cn(
            'h-1.5 flex-1 rounded-full transition-colors',
            s <= current ? 'bg-success' : 'bg-gray-200',
          )}
        />
      ))}
    </div>
  );
}
